'use strict';

import { flow, observable, configure, action, makeObservable } from 'mobx';
configure({enforceActions: 'always'});

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import events from '@uw-it-sis/lib-react/lib/Events';

import PreferredCampusEvents from './PreferredCampusEvents';

import Cookies from 'js-cookie';

const PREFERRED_CAMPUS_COOKIE = "myplan.preferredCampus";

/**
 * Store for pushing preferred campus to the session.
 */
class PreferredCampusStore {

    campus;

    constructor() {
        makeObservable(this, {
            campus: observable,
            mount: action,
            updatePreferredCampus: action
        });

        this.baseUrl = 'api/session/user/attributes';
    }

    /**
     * Initialize the store.
     * @param campus The campus name. Can be undefined.
     */
    mount(campus) {
        if (campus) {
            this.campus = campus;
        } else {
            // If there is a cookie, that means the user has picked a custom campus so use that
            let cookieCampus = Cookies.get(PREFERRED_CAMPUS_COOKIE);
            let registeredCampus = appStore.getUserAttribute('preferredCampus');
            if (cookieCampus) {
                this.campus = cookieCampus;
            }
            // Otherwise, check if there's a preferredCampus on the session which means they are enrolled at that campus
            else if (registeredCampus) {
                this.campus = registeredCampus;
            }

            // Otherwise leave the campus undefined
        }
    }

    /**
     * Updates the preferred campus in the server session. No need to yield for this operation.
     *
     * @param campus The new preferred campus value.
     */
    updatePreferredCampus(campus) {
        //  Hold steady if the campus hasn't changed.
        if (this.campus === campus) {
            if (appStore.isDebug()) {
                console.log(`PreferredCampusStore: Attempted to update preferred campus to the same value: ${campus}`);
            }
            return;
        }

        this.campus = campus;

        // Set the campus cookie. Expire in 1 day
        Cookies.set('myplan.preferredCampus', campus, { expires: 1, sameSite: 'strict', secure: true });

        /*
         * Broadcast the change. This will cause the campus to get updated on any pages
         * that happen to be listening.
         */
        events.emit(PreferredCampusEvents.updatePreferredCampus, campus);

        if (appStore.isDebug()) {
            console.log(`PreferredCampusStore: Updating campus to [${campus}].`);
        }

    };

}

export default new PreferredCampusStore();